import { createReducer } from 'reduxsauce';
import { Types } from './actions';
import reducerBase from '@/domain/base/reducerBase';

const base = reducerBase();

const INITIAL_STATE = {
  ...base.INITIAL_STATE,
  items: []
};

function upsertItem(state: any, courseId: any, changes: any) {
  // Buscamos si ya existe un objeto con ese id
  const index = state.items.findIndex((item: any) => item.id === courseId);

  // Si no existe, lo agregamos
  if (index === -1) {
    return [...state.items, { id: courseId, ...changes }];
  }

  // Si existe, creamos una copia y actualizamos solo lo necesario
  const newItems = [...state.items];
  newItems[index] = { ...newItems[index], ...changes };
  return newItems;
}

const getRegistrationTimesRequest = (state: any, { courseId }: any) => ({
  ...state,
  items: upsertItem(state, courseId, {
    isLoading: true,
    data: null,
    error: null,
    isSuccess: null
  })
});

const getRegistrationTimesSuccess = (state: any, { courseId, data }: any) => ({
  ...state,
  items: upsertItem(state, courseId, {
    isLoading: false,
    data,
    error: null,
    isSuccess: true
  })
});

const getRegistrationTimesFailure = (state: any, { courseId, error }: any) => ({
  ...state,
  items: upsertItem(state, courseId, {
    isLoading: false,
    data: null,
    error,
    isSuccess: false
  })
});

const clearAll = (state: any) => ({
  ...state,
  items: []
});

export default createReducer(INITIAL_STATE, {
  [Types.GET_REGISTRATION_TIMES_REQUEST]: getRegistrationTimesRequest,
  [Types.GET_REGISTRATION_TIMES_SUCCESS]: getRegistrationTimesSuccess,
  [Types.GET_REGISTRATION_TIMES_FAILURE]: getRegistrationTimesFailure,
  [Types.GET_REGISTRATION_TIMES_CLEAR]: clearAll
});
